import React from 'react';
import { autobind } from 'core-decorators';
import { FormGroup } from 'reactstrap';
import LucideIcon from '../lucide-icon';
import ContentManager from '../content-manager';
import DropZoneAnexos from './dropzone/anexos';
import FileBucket from './dropzone/file-bucket';

@autobind
class ArquivoUploadAnexos extends React.Component {
  static defaultProps = {
    formGroupStyle: {},
    iconSize: 20,
    colorBadge: '#ddd',
    colorValue: '#444343',
    disabledClick: false,
    tipoAnexo: null,
    required: false,
    onlyRead: false,
    onlyOneFile: false,
    isFileBucket: false,
    isOnlyDownload: false,
    convertWordToPdf: false,
    extractHeaderText: false,
    urlCustom: null,
    parameters: {},
    documentName: null,
    documentType: null,
    disabledDownload: null,
    showDropzone: true,
  };

  handleClick() {
    if (!this.props.disabledClick) {
      if (this.props.isFileBucket) {
        ContentManager.addContent(
          <FileBucket
            model={this.props.model}
            onUploadFiles={this.handleOnUploadFiles}
            disabled={this.props.disabled}
            disabledDownload={this.props.disabledDownload}
            anexoObrigatorio={this.props.anexoObrigatorio}
            handleAutomaticSave={this.props.handleAutomaticSave}
            onlyRead={this.props.onlyRead}
            onlyOneFile={this.props.onlyOneFile}
            isOnlyDownload={this.props.isOnlyDownload}
            convertWordToPdf={this.props.convertWordToPdf}
            urlCustom={this.props.urlCustom}
            parameters={this.props.parameters}
            documentName={this.props.documentName}
            documentType={this.props.documentType}
            extractTextContent={this.props.extractTextContent}
          />
        );
      } else {
        ContentManager.addContent(
          <DropZoneAnexos
            model={this.props.model}
            onUploadFiles={this.handleOnUploadFiles}
            disabled={this.props.disabled}
            disabledDownload={this.props.disabledDownload}
            tipoAnexo={this.props.tipoAnexo}
            anexoObrigatorio={this.props.anexoObrigatorio}
            handleAutomaticSave={this.props.handleAutomaticSave}
            onlyRead={this.props.onlyRead}
            onlyOneFile={this.props.onlyOneFile}
            showDropzone={this.props.showDropzone}
            convertWordToPdf={this.props.convertWordToPdf}
            urlCustom={this.props.urlCustom}
            parameters={this.props.parameters}
            extractTextContent={this.props.extractTextContent}
          />
        );
      }
    }
  }

  handleOnUploadFiles(arquivos) {
    if (this.props.model.requestChange)
      this.props.model.requestChange(arquivos);

    if (this.props.onChange) this.props.onChange(arquivos);
  }

  hasRequiredError() {
    const hasFormError = !!this.props.model.errors;
    const hasFiles = !!(
      this.props.model.value && this.props.model.value.length > 0
    );
    const isMissingRequired = this.props.required && !hasFiles;

    return hasFormError && isMissingRequired;
  }

  getIconStyle() {
    const hasError = this.hasRequiredError();
    return {
      cursor: !this.props.disabledClick ? 'pointer' : null,
      color: hasError ? '#dc3545' : undefined,
    };
  }

  renderRightLabel() {
    const {
      model,
      required,
      anexoObrigatorio,
      maxWidth = '50px',
      classNameFormGroup = 'd-flex inline pt-4',
    } = this.props;

    return (
      <FormGroup
        className="popupOpen"
        style={this.props.formGroupStyle}
        noMargin={this.props.formGroupStyle?.marginBottom === 0}
        validationstate={model.errors ? 'error' : null}
      >
        <div className={classNameFormGroup} style={{ maxWidth: maxWidth }}>
          <LucideIcon
            size={this.props.iconSize}
            icon="Paperclip"
            style={this.getIconStyle()}
            onClick={this.handleClick}
          />
          {anexoObrigatorio && <span> {anexoObrigatorio ? '*' : ''} </span>}
          {model.value && model.value.length > 0 && (
            <span
              style={{
                backgroundColor: this.props.colorBadge,
                marginTop: 4,
                height: 18,
              }}
              className="badge"
            >
              {model.value.length}{' '}
            </span>
          )}
          {model.label && (
            <label className="control-label pl-1">
              {model.label} {required ? '*' : ''}
            </label>
          )}
        </div>
      </FormGroup>
    );
  }

  renderItem() {
    const { model, required, anexoObrigatorio } = this.props;

    return (
      <>
        {model.label && (
          <label className="control-label">
            {model.label} {required ? '*' : ''}
          </label>
        )}
        <div
          style={{
            maxWidth: '50px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '4px',
          }}
        >
          <LucideIcon
            size={this.props.iconSize}
            icon="Paperclip"
            style={this.getIconStyle()}
            onClick={this.handleClick}
          />
          {anexoObrigatorio && <span> {anexoObrigatorio ? '*' : ''} </span>}
          {model.value && model.value.length > 0 && (
            <span
              style={{
                backgroundColor: this.props.colorBadge,
                color: this.props.colorValue,
              }}
              className="badge"
            >
              {model.value.length}{' '}
            </span>
          )}
        </div>
      </>
    );
  }

  render() {
    const { rightLabel } = this.props;
    return (
      <FormGroup
        className="popupOpen"
        style={this.props.formGroupStyle}
        noMargin={this.props.formGroupStyle?.marginBottom === 0}
        validationstate={this.hasRequiredError() ? 'error' : null}
      >
        {rightLabel ? this.renderRightLabel() : this.renderItem()}
      </FormGroup>
    );
  }
}

export default ArquivoUploadAnexos;
